import React, { useEffect, useState } from 'react'
import JackpotPaymentList, { IPastPayments } from './PastPayments'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getJackpotPaymentsList } from '../../services/jackpotPayments'
import PastPayments from './PastPayments'
import PendingPaymentsList, { IPendingPayments } from './PendingPaymentsList'
import { sendSystemLog } from '../../context/AuthProvider/useAuth'

function index() {
  const loading = useLoading()
  const [jackpotPayments, setJackpotPayments] = useState<IPastPayments[]>([])
  const [jackpotPendingPayments, setJackpotPendingPayments] = useState<IPendingPayments[]>([])
  const log = {
    log_type: 'visited',
    log_object: 'bingo_jackpot_payrolls'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  useEffect(()=>{
    (async () => {
      loading.addLoading()
      const res = await getJackpotPaymentsList()
      setJackpotPayments(res.past_jackpot_payments)
      setJackpotPendingPayments(res.pending_jackpot_payments)
      loading.removeLoading()
    })()
  },[])

  return (
    <div className='jackpot-payments'>
      <h3>Pending Jackpot Payments</h3>
      <PendingPaymentsList payments={jackpotPendingPayments}/>
      <h3>Past Jackpot Payments</h3>
      <JackpotPaymentList payments={jackpotPayments}/>
    </div>
  )
}

export default index